import { webhook } from 'ducks/entities/schema'

export const webhooksApiV0ResponseSchema = [webhook]

export const webhookApiV0ResponseSchema = { webhook }
